type DotObject = Record<string, unknown>;

export function getDotValue<T = unknown>(
  object: unknown,
  path: string,
): T | undefined {
  return path.split('.').reduce<unknown>((value, key) => {
    if (value == null || typeof value !== 'object') {
      return undefined;
    }
    return (value as DotObject)[key];
  }, object) as T | undefined;
}

export function dotObject(object: unknown): DotObject {
  const flattened: DotObject = {};
  flattenObject(object, '', flattened);
  return flattened;
}

function flattenObject(value: unknown, prefix: string, flattened: DotObject) {
  if (!isPlainObject(value)) {
    if (prefix) {
      flattened[prefix] = value;
    }
    return;
  }

  Object.entries(value).forEach(([key, childValue]) => {
    const childKey = prefix ? `${prefix}.${key}` : key;

    if (isPlainObject(childValue)) {
      flattenObject(childValue, childKey, flattened);
    } else {
      flattened[childKey] = childValue;
    }
  });
}

function isPlainObject(value: unknown): value is DotObject {
  return (
    value != null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    !(typeof File !== 'undefined' && value instanceof File)
  );
}
